"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../../../styled"));
var tokens_1 = require("../../../tokens");
var selectOpacity = {
    default: 1,
    disabled: 0.5
};
var hoverBackgroundColor = '#F5F7F9';
exports.optionRenderer = function (providedRenderer) { return function (optionProps) {
    var innerProps = optionProps.innerProps, data = optionProps.data;
    var state = { isHovered: optionProps.isFocused, isDisabled: data.isDisabled };
    var boxContent = providedRenderer(data, state);
    return (React.createElement(exports.OptionElement, __assign({ noStyles: boxContent.props.noStyles }, state, innerProps), boxContent));
}; };
exports.Option = exports.optionRenderer(function (data) { return React.createElement("p", null, data.label); });
exports.OptionElement = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n  padding: ", ";\n  color: ", ";\n  cursor: ", ";\n  opacity: ", ";\n"], ["\n  background-color: ",
    ";\n  display: flex;\n  align-items: center;\n  padding: ", ";\n  color: ", ";\n  cursor: ", ";\n  opacity: ", ";\n"])), function (props) {
    return props.noStyles ? 'none' : props.isHovered ? hoverBackgroundColor : 'white';
}, function (props) { return (props.noStyles ? 'none' : tokens_1.spacing.xsmall + " " + tokens_1.spacing.small); }, tokens_1.colors.text.default, function (props) { return (props.isDisabled ? 'no-drop' : 'pointer'); }, function (props) { return (props.isDisabled ? selectOpacity.disabled : selectOpacity.default); });
var templateObject_1;
//# sourceMappingURL=option.js.map